import { usePublicBoundlessConfigRetrieveSuspense } from "@boundless/bl-api-client/public/services"
import { Headset } from "lucide-react"

import { Button } from "@/components/ui/button"

/**
 * Shown in place of the lender list when Lender Match has nothing to offer,
 * so the borrower has a next step instead of an empty screen.
 */
export function BookACallCard() {
  const { data: boundlessConfig } = usePublicBoundlessConfigRetrieveSuspense()

  return (
    <div className="flex flex-col items-center gap-4 rounded-lg border border-dashed px-6 py-10 text-center">
      <div className="bg-primary/10 text-primary flex size-12 items-center justify-center rounded-full">
        <Headset className="size-6" />
      </div>
      <p className="text-muted-foreground max-w-sm text-sm">
        Boundless needs more information. Please book a call with our support
        team.
      </p>
      {boundlessConfig.bookACallUrl && (
        <Button asChild>
          <a
            href={boundlessConfig.bookACallUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Book a Call
          </a>
        </Button>
      )}
    </div>
  )
}
